import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
	src: PropTypes.string.isRequired,
	className: PropTypes.string,
	children: PropTypes.node
};

const Avatar = ({ src, className, children }) => (
	<div className={className} style={{background: `url('${src}') #fff 70% 70% / cover no-repeat`}}>{children}</div>
);

Avatar.propTypes = propTypes;
export default Avatar;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/avatar.js